import React from 'react'
import C from '../Const'
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from '../recharts'
import U from '../Utils'

function ChartAssunzPerMese(props) {
  let { series, data, print } = props
  let { assunz_per_mese } = data

  // aggiungo etichetta ai mesi
  assunz_per_mese.forEach((item) => {
    item.label = C.MESI[item.month - 1]
  })

  let colors = series.length > 1 ? [C.BLUE, C.RED] : [C.GREEN]

  return (
    <ResponsiveContainer aspect={C.ASPECT} className="ChartAssunzPerMese">
      <BarChart data={assunz_per_mese}>
        <CartesianGrid strokeDasharray="5 5" />
        <XAxis dataKey="label" />
        <YAxis type="number" tickFormatter={U.formatNumber} />
        <Tooltip formatter={U.formatNumber} />
        {series.map((ser, s) => (
          <Bar
            key={s}
            dataKey={'val' + ser.suf}
            fill={colors[s]}
            name={'Media assunz. ' + ser.name}
            isAnimationActive={!print}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  )
}

export default ChartAssunzPerMese



// WEBPACK FOOTER //
// ./src/main/ChartAssunzPerMese.js